


























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import {
  LeftSideLayer,
  RightSideLayer,
  Side,
  LayerMaterials,
  RootsObserved,
  Edges,
  Dividers,
  HorizontalMeasurements,
  VerticalMeasurements
} from "../../types/TrialPitLayers";

@Component({})
export default class TrialPitLayer extends Vue {
  @Prop({ default: () => ({} as LeftSideLayer) }) public layer!:
    | LeftSideLayer
    | RightSideLayer;
  @Prop({ default: "left" }) public side!: Side;

  private materials = LayerMaterials;
  private roots = RootsObserved;
  private edges = Edges;
  private dividers = Dividers;
  private horizontalMeasurements = HorizontalMeasurements;
  private verticalMeasurements = VerticalMeasurements;

  private get leftSideLayer() {
    return this.layer as LeftSideLayer;
  }

  private get rightSideLayer() {
    return this.layer as RightSideLayer;
  }

  private layerPropChanged() {
    if (
      this.layer.topStep !== 0 &&
      this.layer.horizontalMeasurement === "none"
    ) {
      this.layer.horizontalMeasurement = "logTop";
    }
    this.$emit("layerPropChanged");
  }
}
